import { DRAW, END_DRAW } from './constants';

export const draw = () => ({
  type: DRAW,
});

export const endDraw = () => ({
  type: END_DRAW,
});